module.exports = __webpack_public_path__ + "img/evident-olympus.4ecd48ef.png";